import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9c0c64"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "appointInfoPopup",
  class: "popup-vue"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "body-title" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "상담 정보"),
    /*#__PURE__*/_createElementVNode("p", null, "선택한 상담 정보입니다.")
  ])
], -1))
const _hoisted_3 = {
  id: "appointInfo",
  class: "popup-content"
}
const _hoisted_4 = { class: "info-left" }
const _hoisted_5 = { class: "info-part info-patient" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "info-part-title" }, "환자 정보", -1))
const _hoisted_7 = { class: "info-part-content" }
const _hoisted_8 = { class: "tr" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "환자", -1))
const _hoisted_10 = { class: "td" }
const _hoisted_11 = { class: "tr" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "이메일", -1))
const _hoisted_13 = { class: "td" }
const _hoisted_14 = { class: "tr" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "국적", -1))
const _hoisted_16 = { class: "td" }
const _hoisted_17 = { class: "tr" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, [
  /*#__PURE__*/_createTextVNode("매니져"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("이메일")
], -1))
const _hoisted_19 = { class: "td" }
const _hoisted_20 = {
  class: "tr",
  style: {"width":"100%"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "요청 상태", -1))
const _hoisted_22 = { class: "td color-main" }
const _hoisted_23 = { class: "info-appoint" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "info-part-title" }, "상담 내용", -1))
const _hoisted_25 = { class: "info-part-content" }
const _hoisted_26 = { class: "appoint-title" }
const _hoisted_27 = { class: "appoint-content-wrap" }
const _hoisted_28 = { class: "appoint-content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "hidden" }, "내용", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "hidden" }, "첨부 이미지", -1))
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "info-right" }
const _hoisted_33 = { class: "info-doctor" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "info-part-title" }, "의료진 정보", -1))
const _hoisted_35 = { class: "info-part-content" }
const _hoisted_36 = { class: "tr" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "의료진", -1))
const _hoisted_38 = { class: "td" }
const _hoisted_39 = { class: "tr" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "이메일", -1))
const _hoisted_41 = { class: "td" }
const _hoisted_42 = { class: "tr" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "국적", -1))
const _hoisted_44 = { class: "td" }
const _hoisted_45 = { class: "tr" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, [
  /*#__PURE__*/_createTextVNode("매니져"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("이메일")
], -1))
const _hoisted_47 = { class: "td" }
const _hoisted_48 = { class: "tr" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "소속", -1))
const _hoisted_50 = { class: "td" }
const _hoisted_51 = { class: "tr" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "응답 상태", -1))
const _hoisted_53 = { class: "td color-main" }
const _hoisted_54 = { class: "info-schedule" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "info-part info-part-title" }, "상담 스케쥴", -1))
const _hoisted_56 = { class: "info-part-content" }
const _hoisted_57 = { class: "tr" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "상담 날짜", -1))
const _hoisted_59 = { class: "td" }
const _hoisted_60 = { class: "tr" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "상담 시간", -1))
const _hoisted_62 = { class: "td" }
const _hoisted_63 = { class: "tr" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "종료 시간", -1))
const _hoisted_65 = { class: "td color-main" }
const _hoisted_66 = { class: "tr" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "th" }, "진행 상태", -1))
const _hoisted_68 = { class: "td color-main" }
const _hoisted_69 = { class: "info-memo" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "" }, "상담 메모", -1))
const _hoisted_71 = { class: "memo-content-wrap" }
const _hoisted_72 = { class: "memo-content" }
const _hoisted_73 = { class: "info-reject" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "" }, "반려사유", -1))
const _hoisted_75 = { class: "reject-content-wrap" }
const _hoisted_76 = { class: "reject-content color-point" }
const _hoisted_77 = {
  key: 0,
  class: "list-loading-layer"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-loading" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..")
], -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { class: "popup-bottom btn-wrap" }

import { onMounted } from 'vue';
import { computed, ref } from '@vue/reactivity';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppointInfoPopup',
  props: {
  popupTitle: {
    type: String,
    required: false,
  },
  appointSid: {
    type: Number,
    required: false,
  },
},
  emits: ['onClick_close'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const Appt = store.state.moduleAppt;


/**** data -------------------- */
var appointInfo = computed(() => Appt.appointInfo);
var isOnLoading_appointInfo = ref(false);
/**** methods ----------------- */
var setAppointInfo = async () => {
  isOnLoading_appointInfo.value = true;
  await store.dispatch('moduleAppt/getAppointInfo', props.appointSid, { root: true });
};
/**** content -----------------
 * 상담 정보
 * /
 */
/**** hook -------------------- */
onMounted(() => {
  setAppointInfo();
  setTimeout(() => {
    isOnLoading_appointInfo.value = false;
  }, 400);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(appointInfo).patient.name), 1)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(appointInfo).patient.patientEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(appointInfo).patient.nationality), 1)
            ]),
            _createElementVNode("li", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(appointInfo).patient.managerEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(appointInfo).patient.state), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h3", _hoisted_26, _toDisplayString(_unref(appointInfo).detail.title), 1),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", null, _toDisplayString(_unref(appointInfo).detail.content), 1),
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appointInfo).detail.images, (item) => {
                  return (_openBlock(), _createElementBlock("ul", { key: item }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("img", {
                        src: item.image_url,
                        alt: item.image_desc
                      }, null, 8, _hoisted_31)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("ul", _hoisted_35, [
            _createElementVNode("li", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(appointInfo).doctor.name), 1)
            ]),
            _createElementVNode("li", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(appointInfo).doctor.doctorEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(appointInfo).doctor.nationality), 1)
            ]),
            _createElementVNode("li", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(appointInfo).doctor.managerEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(appointInfo).doctor.affiliation), 1)
            ]),
            _createElementVNode("li", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(appointInfo).doctor.state), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("ul", _hoisted_56, [
            _createElementVNode("li", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(appointInfo).schedule.date), 1)
            ]),
            _createElementVNode("li", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(appointInfo).schedule.time), 1)
            ]),
            _createElementVNode("li", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(appointInfo).schedule.endTime), 1)
            ]),
            _createElementVNode("li", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(appointInfo).schedule.state), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(appointInfo).schedule.memo), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(appointInfo).schedule.reject), 1)
            ])
          ])
        ])
      ])
    ]),
    (_unref(isOnLoading_appointInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_79))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("button", {
        class: "btn-confirm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_close')))
      }, "닫기")
    ])
  ]))
}
}

})